import { useCallback } from 'react';

import { type EmailQuerySchema, useCreateMutation, useUpdateMutation } from './shared';

export function useFormInputMultipleEmails() {
  const { isPending, mutateAsync } = useCreateMutation();
  const { isPending: updateIsPending, mutateAsync: updateMutateSync } = useUpdateMutation();

  const handleAddEmail = useCallback(
    async (newV: EmailQuerySchema) => {
      try {
        const response = await mutateAsync({ email: newV.email });
        if (response.data) {
          return { ...newV, ...response.data };
        }
      } catch (error) {
        console.error(error);
        return false;
      }
      return false;
    },
    [mutateAsync]
  );

  const handleUpdateEmail = useCallback(
    async (email: EmailQuerySchema) => {
      try {
        const response = await updateMutateSync({ email: email.email, id: email.id });
        if (response.data) {
          return { ...email };
        }
      } catch (error) {
        console.error(error);
        return false;
      }
      return false;
    },
    [updateMutateSync]
  );

  const handleEmails = useCallback(
    async (emails: EmailQuerySchema[]) => {
      const arrayOfEmails: Promise<EmailQuerySchema | false>[] = [];
      emails.forEach(async (email) => {
        if (email.intent === 'create') {
          arrayOfEmails.push(handleAddEmail(email));
        } else if (email.intent === 'update') {
          arrayOfEmails.push(handleUpdateEmail(email));
        } else {
          arrayOfEmails.push(Promise.resolve(email));
        }
      });

      const result = await Promise.all(arrayOfEmails);

      if (result.some((r) => r === false)) return false;

      return result as EmailQuerySchema[];
    },
    [handleAddEmail, handleUpdateEmail]
  );

  return { handleEmails, isEmailsPending: isPending || updateIsPending };
}
